var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConcluded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#59BF8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7652 6.20192C15.0649 6.48351 15.0797 6.95479 14.7981 7.25455L8.69252 13.754L5.25431 10.7456C4.9448 10.4748 4.91343 10.0043 5.18426 9.69477C5.45509 9.38526 5.92555 9.35389 6.23507 9.62472L8.59133 11.6865L13.7126 6.23482C13.9942 5.93506 14.4654 5.92033 14.7652 6.20192Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcluded);
export default __webpack_public_path__ + "static/media/concluded.911a7f92d0d97442b12ec36a9402b6f0.svg";
export { ForwardRef as ReactComponent };